// Modified LoadingOrchestrator.js
import { create } from "zustand";

export const LOADING_STAGES = {
  INITIAL: 0, // Initial loading
  FURNITURE: 1, // Room furniture - moved to load first
  FRAMETYPES: 2, // Frame type components - show basic UI at this point
  MATERIALS: 3, // Material textures
  COMPLETE: 4, // Everything is loaded
};

export const useLoadingStore = create((set, get) => ({
  loadingStage: LOADING_STAGES.INITIAL,
  progress: 0,
  errors: [],
  imageLoaded: false,
  loadingComplete: false,
  uiReady: false, // New flag to indicate when the UI should be shown

  setLoadingStage: (stage) => set({ loadingStage: stage, progress: 0 }),
  setProgress: (progress) => set({ progress }),
  setImageLoaded: (loaded) =>
    set((state) => {
      console.log(`Setting imageLoaded: ${loaded}`);
      return { imageLoaded: loaded };
    }),

  // New function to mark UI as ready to show
  setUIReady: (ready) => set({ uiReady: ready }),

  addError: (error) =>
    set((state) => ({
      errors: [...state.errors, error],
    })),

  advanceStage: () =>
    set((state) => {
      const nextStage = Math.min(
        state.loadingStage + 1,
        LOADING_STAGES.COMPLETE
      );
      const loadingComplete = nextStage === LOADING_STAGES.COMPLETE;

      // Mark UI as ready at INITIAL stage to allow furniture to render immediately
      const uiReady = true; // Always allow UI to show

      console.log(
        `Advancing stage: ${state.loadingStage} -> ${nextStage}, UI Ready: ${uiReady}`
      );

      return {
        loadingStage: nextStage,
        progress: 0,
        loadingComplete,
        uiReady,
      };
    }),

  checkComplete: () =>
    set((state) => {
      const loadingComplete = state.loadingStage === LOADING_STAGES.COMPLETE;
      console.log(
        `Checking complete: stage=${state.loadingStage}, complete=${loadingComplete}`
      );

      return { loadingComplete };
    }),

  reset: () =>
    set({
      loadingStage: LOADING_STAGES.INITIAL,
      progress: 0,
      errors: [],
      imageLoaded: false,
      loadingComplete: false,
      uiReady: false,
    }),
}));
